import BackendAPI from './BackendAPI';
import GooglePlacesAPI from './GooglePlacesAPI';

const api = {
    backend: BackendAPI,
    googlePlaces: GooglePlacesAPI
};

export default api;
